import * as React from 'react'

import { ReportType } from '@/app/constants/reportType'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import PrintoutParamsRenderer from '../renders/PrintoutParamsRenderer'
import { RaportFormProvider, useRaportForm } from '../context/RaportFormContext'
import { useReportParamsStore } from '../stores/reportParamsStore'
import { DEFAULT_SIGNATURES } from '../utils/reportDefaultParams'

type Props = {
  report: ReportType
  companyId: string
}

/**
 * Opcje raportu rozwijane pod jego wierszem - jak RowDetails w PrintoutDataView
 * WPF. Zmiany trafiaja od razu do opcji raportu, z ktorych korzysta wydruk
 * grupowy; nic sie tu nie drukuje.
 */
export const ReportParamsPanel: React.FC<Props> = ({ report, companyId }) => {
  const { t } = useLocalize()
  // Zakres dat strony - z niego formularze biora domyslny okres.
  const { dateRange } = useRaportForm()
  const setParams = useReportParamsStore((s) => s.setParams)
  const initialData = React.useMemo(
    () => useReportParamsStore.getState().paramsByReport[report] ?? DEFAULT_SIGNATURES,
    [report],
  )

  const handleDataChange = React.useCallback(
    (data: Record<string, any>) => setParams(report, data),
    [report, setParams],
  )

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      className="tw-cursor-default tw-border-b tw-border-secondary/40 tw-bg-primary/5"
    >
      <RaportFormProvider
        key={report}
        initialData={initialData}
        onDataChange={handleDataChange}
        signaturesFor={report}
      >
        {/* Szerokosc dawnego okna parametrow - uklad formularza bez zmian. */}
        <div className="tw-max-w-[800px]">
          <PrintoutParamsRenderer
            companyId={companyId}
            selectedReport={report}
            translate={t}
            dateRange={dateRange}
          />
        </div>
      </RaportFormProvider>
    </div>
  )
}

export default ReportParamsPanel
